import { DialogContext } from '@/components/ui/shared/Dialog';
import { useContext } from 'react';

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('DialogContext not found in the tree-nodes');
  }
  return {
    showDialog: context.showDialog,
    removeDialog: context.removeDialog,
    removeAllDialogs: context.removeAllDialogs,
  };
};
